/**
 * AthleteCampaignBanner — V9.18 Sprint 4
 * Affiche un CTA "Soutenir son projet" sur la fiche athlète UNIQUEMENT
 * si une campagne active existe. Sinon, ne rend rien (pas de bloc vide).
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shirt, HandHeart, ArrowRight } from "lucide-react";

export function AthleteCampaignBanner({ athleteId }) {
  const [campaign, setCampaign] = useState(null);
  useEffect(() => {
    if (!athleteId) return;
    let cancelled = false;
    api.get(`/campaigns/athlete/${athleteId}/active`)
      .then((r) => { if (!cancelled) setCampaign(r.data); })
      .catch(() => { if (!cancelled) setCampaign(null); });
    return () => { cancelled = true; };
  }, [athleteId]);

  if (!campaign) return null;
  // V9.19 : les campagnes SupportCampaign V1 sont gérées par SupportCampaignBanner
  if (campaign.support_v1) return null;

  const currentT = (campaign.tranches || []).find((t) => t.tranche_number === campaign.current_tranche_number);
  const confirmed = currentT?.confirmed_count || 0;
  const batch = currentT?.batch_size || campaign.batch_size || 20;
  const pct = Math.min(100, Math.round((confirmed / batch) * 100));

  return (
    <Card className="p-4 border-l-4 border-[hsl(var(--aito-gold))] bg-[hsl(var(--aito-gold))]/5" data-testid="athlete-campaign-banner">
      <div className="flex items-start gap-3 flex-wrap">
        <div className="h-11 w-11 rounded-md bg-[hsl(var(--aito-gold))]/20 flex items-center justify-center text-[hsl(var(--aito-gold))] shrink-0">
          <Shirt className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold text-sm">Soutenir son projet</div>
          <div className="text-xs text-muted-foreground line-clamp-2">{campaign.title}</div>
          <div className="mt-2 flex items-center gap-2 flex-wrap">
            <div className="h-2 flex-1 min-w-[120px] rounded-full bg-secondary overflow-hidden">
              <div className="h-full bg-[hsl(var(--aito-lagoon))]" style={{ width: `${pct}%` }} />
            </div>
            <span className="text-[11px] font-semibold whitespace-nowrap">{confirmed}/{batch}</span>
          </div>
        </div>
        <Link to={`/soutien/campagnes/${campaign.slug}`}>
          <Button size="sm" className="bg-[hsl(var(--aito-lagoon))] text-black hover:bg-[hsl(var(--aito-lagoon-2))]" data-testid="athlete-campaign-cta">
            <HandHeart className="h-4 w-4 mr-1.5" />Je précommande <ArrowRight className="h-3.5 w-3.5 ml-1" />
          </Button>
        </Link>
      </div>
    </Card>
  );
}

export default AthleteCampaignBanner;
